import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import qrcode from "qrcode";
import html2canvas from "html2canvas";
import { mapState } from "vuex";
import { getCurrentLanguageCode } from "@/utils/util";
export default {
  name: "InviteLinkModal",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      visiable: false,
      canvasRef: null
    };
  },
  computed: {
    deptName() {
      return this.value.orgName || "";
    },
    inviteLanguage() {
      return getCurrentLanguageCode(this.languageCode);
    },
    link() {
      const url = new URL("/Invites", window.location.origin);
      url.searchParams.set("inviteCode", this.value.inviteCode || "");
      if (this.inviteLanguage) {
        url.searchParams.set("lang", this.inviteLanguage);
      }
      return url.toString();
    },
    copyText() {
      return {
        text: `${$t('jstjjxa', '点击链接加入我们吧！')}${this.link}`,
        html: `${$t('xkfo631p', '<p>点击链接加入我们吧！<a class="text-[#3D7FFF]" target="_blank" href="')}${this.link}">${this.link}</a></p>`
      };
    },
    ...mapState({
      user: state => state.user,
      languageCode: state => state.app.language
    })
  },
  watch: {
    "value.inviteCode": {
      handler(newVal) {
        if (newVal && this.value.isInvalid === "F") {
          this.visiable = true;
        } else {
          this.visiable = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.initQRcode();
      });
    },
    hide() {
      this.visiable = false;
    },
    copy() {
      let res = this.copyToClipboard(this.link);
      if (res) {
        this.$Message.success($t("bkv2mw4", "复制成功"));
      } else {
        this.$Message.error($t("bktvvh4", "复制失败"));
      }
    },
    initQRcode() {
      qrcode.toCanvas(this.$refs.canvasRef, this.link, {
        width: 100,
        margin: 1
      });
      qrcode.toDataURL(this.$refs.qrcodeCanvas, this.link, {
        width: 200,
        margin: 1
      });
    },
    downLoad() {
      html2canvas(this.$refs.downloadRef, {
        scale: 2,
        backgroundColor: "#ffffff",
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const link = document.createElement("a");
        link.download = $t("eqg8ci5", "邀请二维码");
        link.href = canvas.toDataURL("image/png");
        console.log(canvas.toDataURL("image/png"));
        link.click();
      });
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(text).then(() => {
          return true;
        }).catch(() => {
          return false;
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          const successful = document.execCommand("copy");
          document.body.removeChild(textArea);
          return successful;
        } catch (err) {
          document.body.removeChild(textArea);
          return false;
        }
      }
    }
  }
};